// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Color Constants */
:root {
    /* Primaries */
    --primary-dark: #434DCF;
    --primary-dark-1: #013263;
    --primary-dark-2: #3237A0;
    --primary-medium: #6F78DE;
    --primary-medium-2: #EEEFFB;
    --primary-medium-light: #9197da;
    --primary-light: #DCDFFF;
    --primary-light-2: #F4F5FF;
    --primary-light-3: #D5D7EE;
    --link-primary: #61dafb;
    --hover-primary-dark: #3b44a2;
    /* Neutrals (backgrounds/ layout blocks/ outlines) */
    --neutral-white: #FFFFFF;
    --light-neutral-1: #FDFDFD;
    --light-neutral-2: #F2F3F9;
    --light-neutral-3: #E4E6F3;
    --light-neutral-4: #CECAD7;
    --light-neutral-5: #D9D9D9;
    --light-neutral-6: #F7F8FB;
    --light-neutral-7: #D1CAE1;
    --light-neutral-8: #949494;
    --light-neutral-9: #FFE5EA;
    --light-neutral-10: #F9F8F2;
    --light-neutral-11: #F2F9F8;
    --light-neutral-12: #F9F2F2;
    --light-neutral-13: #FEF5E3;
    --light-neutral-14: #EAECFF;
    --date-background: #F7F7F7;
    --neutral-dark-1: #282c34;
    /* Neutrals (texts/icons) */
    --dark-neutral-1: #ACADAD;
    --dark-neutral-2: #78828C;
    --dark-neutral-3: #2D363D;
    --dark-neutral-4: #373A3E;
    --dark-neutral-5: #634701;
    --dark-neutral-6: #630101;
    --dark-neutral-7: #4D5154;
    --almost-black: #303336;
    --black: #000000;
    --dark-neutral-text: #16171B;
    /* Specials */
    --star-yellow-1: #F19B50;
    --star-yellow-2: #FFCC7F;
    --star-yellow-3: #FFF8E7;
    --green-1: #1D7A59;
    --green-2: #A4E7C7;
    --green-3: #EBFBE9;
    --green-4: #016322;
    --green-5: #1A936F;
    --red-1: #EC4646;
    --red-2: #FFAFAF;
    --red-3: #FBE9F1;
    --red-4: #FCE1E1;
    --red-5: #FFEDEB;
    --red-6: #FFDADA;
    --link-blue: #0057FF;
    --system-blue: #3A82F7;
    --disclaimer-1: #514B28;
    --disclaimer-2: #D6D0B4;
    --disclaimer-3: #FFF5C1;
    --disclaimer-4: #A5540E;
    --red-button: #B91F1F;
    --border-color: #434CB8;
    --link-color: #1C33FF;
    --active-speaker-div: #B6BAE6;
    --border-light: #ebebeb;
    --border-top-light: #e1e1e1;
    --neutral-overlay: #373B6857;
    --shadow-color: #9597B28C;
    --shadow-color-light: #9395AE;
    --red-alert: #E70000;
    --red-alert-2: #F55014;
    --success-background: #D4F4DD;
    --error-background: #F8D7DA;
    --success-text: #155724;
    --error-text: #721C24;
    --tooltip-text: #25284C;

    --border-neutral: #EEEEEE;
    /* Chips bg colors */
    --accent-peach: #FFEAE8;
    --accent-lavender: #E8ECFF;
    --accent-amber: #FFECBD;
    --accent-lilac: #FFEBFF;
    --accent-mint: #F3FBEE;
    --accent-rose: #FFDEDF;
    --accent-apricot: #FFF4E6;
    --accent-periwinkle: #E6E6FF;
    /* chips border colors */
    --border-peach: #FDCBC6;
    --border-lavender: #CCD5FF;
    --border-amber: #FBDA87;
    --border-lilac: #FFC4FF;
    --border-mint: #C6FFA2;
    --border-rose: #FFA5A8;
    --border-apricot: #FFD6A2;
    --border-periwinkle: #B5B5FF;
    /* chips text colors */
    --text-peach: #9C4221;
    --text-lavender: #2741BB;
    --text-amber: #5E4300;
    --text-lilac: #B309B3;
    --text-mint: #2E7900;
    --text-rose: #940004;
    --text-apricot: #542F00;
    --text-periwinkle: #2525E5;
}

.pwa-theme{
    /* Primaries */
    --primary-dark: #434DCF;
    --primary-dark-1: #013263;
    --primary-dark-2: #3237A0;
    --primary-medium: #6F78DE;
    --primary-medium-2: #EEEFFB;
    --primary-medium-light: #9197da;
    --primary-light: #DCDFFF;
    --primary-light-2: #F4F5FF;
    --primary-light-3: #D5D7EE;
    --link-primary: #61dafb;
    --hover-primary-dark: #3b44a2;
    /* Neutrals (backgrounds/ layout blocks/ outlines) */
    --neutral-white: #FFFFFF;
    --light-neutral-1: #FDFDFD;
    --light-neutral-2: #F2F3F9;
    --light-neutral-3: #E4E6F3;
    --light-neutral-4: #CECAD7;
    --light-neutral-5: #D9D9D9;
    --light-neutral-6: #F7F8FB;
    --light-neutral-7: #D1CAE1;
    --light-neutral-8: #949494;
    --light-neutral-9: #FFE5EA;
    --light-neutral-10: #F9F8F2;
    --light-neutral-11: #F2F9F8;
    --light-neutral-12: #F9F2F2;
    --light-neutral-13: #FEF5E3;
    --light-neutral-14: #EAECFF;
    --date-background: #F7F7F7;
    --neutral-dark-1: #282c34;
    /* Neutrals (texts/icons) */
    --dark-neutral-1: #ACADAD;
    --dark-neutral-2: #78828C;
    --dark-neutral-3: #2D363D;
    --dark-neutral-4: #373A3E;
    --dark-neutral-5: #634701;
    --dark-neutral-6: #630101;
    --dark-neutral-7: #4D5154;
    --almost-black: #303336;
    --black: #000000;
    --dark-neutral-text: #16171B;
    /* Specials */
    --star-yellow-1: #F19B50;
    --star-yellow-2: #FFCC7F;
    --star-yellow-3: #FFF8E7;
    --green-1: #1D7A59;
    --green-2: #A4E7C7;
    --green-3: #EBFBE9;
    --green-4: #016322;
    --green-5: #1A936F;
    --red-1: #EC4646;
    --red-2: #FFAFAF;
    --red-3: #FBE9F1;
    --red-4: #FCE1E1;
    --red-5: #FFEDEB;
    --red-6: #FFDADA;
    --link-blue: #0057FF;
    --system-blue: #3A82F7;
    --disclaimer-1: #514B28;
    --disclaimer-2: #D6D0B4;
    --disclaimer-3: #FFF5C1;
    --disclaimer-4: #A5540E;
    --red-button: #B91F1F;
    --border-color: #434CB8;
    --link-color: #1C33FF;
    --active-speaker-div: #B6BAE6;
    --border-light: #ebebeb;
    --border-top-light: #e1e1e1;
    --neutral-overlay: #373B6857;
    --shadow-color: #9597B28C;
    --shadow-color-light: #9395AE;
    --red-alert: #E70000;
    --red-alert-2: #F55014;
    --success-background: #D4F4DD;
    --error-background: #F8D7DA;
    --success-text: #155724;
    --error-text: #721C24;
    --tooltip-text: #25284C;

    --border-neutral: #EEEEEE;
    /* Chips bg colors */
    --accent-peach: #FFEAE8;
    --accent-lavender: #E8ECFF;
    --accent-amber: #FFECBD;
    --accent-lilac: #FFEBFF;
    --accent-mint: #F3FBEE;
    --accent-rose: #FFDEDF;
    --accent-apricot: #FFF4E6;
    --accent-periwinkle: #E6E6FF;
    /* chips border colors */
    --border-peach: #FDCBC6;
    --border-lavender: #CCD5FF;
    --border-amber: #FBDA87;
    --border-lilac: #FFC4FF;
    --border-mint: #C6FFA2;
    --border-rose: #FFA5A8;
    --border-apricot: #FFD6A2;
    --border-periwinkle: #B5B5FF;
    /* chips text colors */
    --text-peach: #9C4221;
    --text-lavender: #2741BB;
    --text-amber: #5E4300;
    --text-lilac: #B309B3;
    --text-mint: #2E7900;
    --text-rose: #940004;
    --text-apricot: #542F00;
    --text-periwinkle: #2525E5;
}

.iframe-theme{
    /* Primaries */
    --primary-dark: #DA5B54;
    --primary-dark-1: #013263;
    --primary-dark-2: #DA5B54;
    --primary-medium: #6F78DE;
    --primary-medium-2: #EEEFFB;
    --primary-medium-light: #9197da;
    --primary-light: #DCDFFF;
    --primary-light-2: #F4F5FF;
    --primary-light-3: #D5D7EE;
    --link-primary: #61dafb;
    --hover-primary-dark: #3b44a2;
    /* Neutrals (backgrounds/ layout blocks/ outlines) */
    --neutral-white: #FFFFFF;
    --light-neutral-1: #FDFDFD;
    --light-neutral-2: #F2F3F9;
    --light-neutral-3: #EEE7E7;
    --light-neutral-4: #EEE7E7;
    --light-neutral-5: #D9D9D9;
    --light-neutral-6: #F7F8FB;
    --light-neutral-7: #D1CAE1;
    --light-neutral-8: #949494;
    --light-neutral-9: #FFE5EA;
    --light-neutral-10: #F9F8F2;
    --light-neutral-11: #F2F9F8;
    --light-neutral-12: #F9F2F2;
    --light-neutral-13: #FFF6F8;
    --light-neutral-14: #EAECFF;
    --date-background: #F7F7F7;
    --neutral-dark-1: #282c34;
    /* Neutrals (texts/icons) */
    --dark-neutral-1: #ACADAD;
    --dark-neutral-2: #78828C;
    --dark-neutral-3: #2D363D;
    --dark-neutral-4: #373A3E;
    --dark-neutral-5: #634701;
    --dark-neutral-6: #630101;
    --dark-neutral-7: #4D5154;
    --almost-black: #303336;
    --black: #000000;
    --dark-neutral-text: #16171B;
    /* Specials */
    --star-yellow-1: #F19B50;
    --star-yellow-2: #FFCC7F;
    --star-yellow-3: #FFF8E7;
    --green-1: #1D7A59;
    --green-2: #A4E7C7;
    --green-3: #EBFBE9;
    --green-4: #016322;
    --green-5: #1A936F;
    --red-1: #EC4646;
    --red-2: #FFAFAF;
    --red-3: #FBE9F1;
    --red-4: #FCE1E1;
    --red-5: #FFEDEB;
    --red-6: #FFDADA;
    --link-blue: #0057FF;
    --system-blue: #3A82F7;
    --disclaimer-1: #514B28;
    --disclaimer-2: #D6D0B4;
    --disclaimer-3: #FFF5C1;
    --disclaimer-4: #A5540E;
    --red-button: #B91F1F;
    --border-color: #DA5B54;
    --link-color: #1C33FF;
    --active-speaker-div: #FFEDEB;
    --border-light: #ebebeb;
    --border-top-light: #e1e1e1;
    --neutral-overlay: #373B6857;
    --shadow-color: #9597B28C;
    --shadow-color-light: #9395AE;
    --red-alert: #E70000;
    --red-alert-2: #F55014;
    --success-background: #D4F4DD;
    --error-background: #F8D7DA;
    --success-text: #155724;
    --error-text: #721C24;
    --tooltip-text: #25284C;

    --border-neutral: #EEEEEE;
    /* Chips bg colors */
    --accent-peach: #FFEAE8;
    --accent-lavender: #E8ECFF;
    --accent-amber: #FFECBD;
    --accent-lilac: #FFEBFF;
    --accent-mint: #F3FBEE;
    --accent-rose: #FFDEDF;
    --accent-apricot: #FFF4E6;
    --accent-periwinkle: #E6E6FF;
    /* chips border colors */
    --border-peach: #FDCBC6;
    --border-lavender: #CCD5FF;
    --border-amber: #FBDA87;
    --border-lilac: #FFC4FF;
    --border-mint: #C6FFA2;
    --border-rose: #FFA5A8;
    --border-apricot: #FFD6A2;
    --border-periwinkle: #B5B5FF;
    /* chips text colors */
    --text-peach: #9C4221;
    --text-lavender: #2741BB;
    --text-amber: #5E4300;
    --text-lilac: #B309B3;
    --text-mint: #2E7900;
    --text-rose: #940004;
    --text-apricot: #542F00;
    --text-periwinkle: #2525E5;
}`, "",{"version":3,"sources":["webpack://./src/color-constants.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,+BAA+B;IAC/B,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,oDAAoD;IACpD,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;;IAEvB,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,wBAAwB;IACxB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;IACtB,qBAAqB;IACrB,wBAAwB;IACxB,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,+BAA+B;IAC/B,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,oDAAoD;IACpD,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;;IAEvB,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,wBAAwB;IACxB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;IACtB,qBAAqB;IACrB,wBAAwB;IACxB,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,2BAA2B;IAC3B,+BAA+B;IAC/B,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,oDAAoD;IACpD,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;;IAEvB,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,wBAAwB;IACxB,uBAAuB;IACvB,0BAA0B;IAC1B,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;IACtB,qBAAqB;IACrB,wBAAwB;IACxB,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB;IACvB,0BAA0B;AAC9B","sourcesContent":["/* Color Constants */\r\n:root {\r\n    /* Primaries */\r\n    --primary-dark: #434DCF;\r\n    --primary-dark-1: #013263;\r\n    --primary-dark-2: #3237A0;\r\n    --primary-medium: #6F78DE;\r\n    --primary-medium-2: #EEEFFB;\r\n    --primary-medium-light: #9197da;\r\n    --primary-light: #DCDFFF;\r\n    --primary-light-2: #F4F5FF;\r\n    --primary-light-3: #D5D7EE;\r\n    --link-primary: #61dafb;\r\n    --hover-primary-dark: #3b44a2;\r\n    /* Neutrals (backgrounds/ layout blocks/ outlines) */\r\n    --neutral-white: #FFFFFF;\r\n    --light-neutral-1: #FDFDFD;\r\n    --light-neutral-2: #F2F3F9;\r\n    --light-neutral-3: #E4E6F3;\r\n    --light-neutral-4: #CECAD7;\r\n    --light-neutral-5: #D9D9D9;\r\n    --light-neutral-6: #F7F8FB;\r\n    --light-neutral-7: #D1CAE1;\r\n    --light-neutral-8: #949494;\r\n    --light-neutral-9: #FFE5EA;\r\n    --light-neutral-10: #F9F8F2;\r\n    --light-neutral-11: #F2F9F8;\r\n    --light-neutral-12: #F9F2F2;\r\n    --light-neutral-13: #FEF5E3;\r\n    --light-neutral-14: #EAECFF;\r\n    --date-background: #F7F7F7;\r\n    --neutral-dark-1: #282c34;\r\n    /* Neutrals (texts/icons) */\r\n    --dark-neutral-1: #ACADAD;\r\n    --dark-neutral-2: #78828C;\r\n    --dark-neutral-3: #2D363D;\r\n    --dark-neutral-4: #373A3E;\r\n    --dark-neutral-5: #634701;\r\n    --dark-neutral-6: #630101;\r\n    --dark-neutral-7: #4D5154;\r\n    --almost-black: #303336;\r\n    --black: #000000;\r\n    --dark-neutral-text: #16171B;\r\n    /* Specials */\r\n    --star-yellow-1: #F19B50;\r\n    --star-yellow-2: #FFCC7F;\r\n    --star-yellow-3: #FFF8E7;\r\n    --green-1: #1D7A59;\r\n    --green-2: #A4E7C7;\r\n    --green-3: #EBFBE9;\r\n    --green-4: #016322;\r\n    --green-5: #1A936F;\r\n    --red-1: #EC4646;\r\n    --red-2: #FFAFAF;\r\n    --red-3: #FBE9F1;\r\n    --red-4: #FCE1E1;\r\n    --red-5: #FFEDEB;\r\n    --red-6: #FFDADA;\r\n    --link-blue: #0057FF;\r\n    --system-blue: #3A82F7;\r\n    --disclaimer-1: #514B28;\r\n    --disclaimer-2: #D6D0B4;\r\n    --disclaimer-3: #FFF5C1;\r\n    --disclaimer-4: #A5540E;\r\n    --red-button: #B91F1F;\r\n    --border-color: #434CB8;\r\n    --link-color: #1C33FF;\r\n    --active-speaker-div: #B6BAE6;\r\n    --border-light: #ebebeb;\r\n    --border-top-light: #e1e1e1;\r\n    --neutral-overlay: #373B6857;\r\n    --shadow-color: #9597B28C;\r\n    --shadow-color-light: #9395AE;\r\n    --red-alert: #E70000;\r\n    --red-alert-2: #F55014;\r\n    --success-background: #D4F4DD;\r\n    --error-background: #F8D7DA;\r\n    --success-text: #155724;\r\n    --error-text: #721C24;\r\n    --tooltip-text: #25284C;\r\n\r\n    --border-neutral: #EEEEEE;\r\n    /* Chips bg colors */\r\n    --accent-peach: #FFEAE8;\r\n    --accent-lavender: #E8ECFF;\r\n    --accent-amber: #FFECBD;\r\n    --accent-lilac: #FFEBFF;\r\n    --accent-mint: #F3FBEE;\r\n    --accent-rose: #FFDEDF;\r\n    --accent-apricot: #FFF4E6;\r\n    --accent-periwinkle: #E6E6FF;\r\n    /* chips border colors */\r\n    --border-peach: #FDCBC6;\r\n    --border-lavender: #CCD5FF;\r\n    --border-amber: #FBDA87;\r\n    --border-lilac: #FFC4FF;\r\n    --border-mint: #C6FFA2;\r\n    --border-rose: #FFA5A8;\r\n    --border-apricot: #FFD6A2;\r\n    --border-periwinkle: #B5B5FF;\r\n    /* chips text colors */\r\n    --text-peach: #9C4221;\r\n    --text-lavender: #2741BB;\r\n    --text-amber: #5E4300;\r\n    --text-lilac: #B309B3;\r\n    --text-mint: #2E7900;\r\n    --text-rose: #940004;\r\n    --text-apricot: #542F00;\r\n    --text-periwinkle: #2525E5;\r\n}\r\n\r\n.pwa-theme{\r\n    /* Primaries */\r\n    --primary-dark: #434DCF;\r\n    --primary-dark-1: #013263;\r\n    --primary-dark-2: #3237A0;\r\n    --primary-medium: #6F78DE;\r\n    --primary-medium-2: #EEEFFB;\r\n    --primary-medium-light: #9197da;\r\n    --primary-light: #DCDFFF;\r\n    --primary-light-2: #F4F5FF;\r\n    --primary-light-3: #D5D7EE;\r\n    --link-primary: #61dafb;\r\n    --hover-primary-dark: #3b44a2;\r\n    /* Neutrals (backgrounds/ layout blocks/ outlines) */\r\n    --neutral-white: #FFFFFF;\r\n    --light-neutral-1: #FDFDFD;\r\n    --light-neutral-2: #F2F3F9;\r\n    --light-neutral-3: #E4E6F3;\r\n    --light-neutral-4: #CECAD7;\r\n    --light-neutral-5: #D9D9D9;\r\n    --light-neutral-6: #F7F8FB;\r\n    --light-neutral-7: #D1CAE1;\r\n    --light-neutral-8: #949494;\r\n    --light-neutral-9: #FFE5EA;\r\n    --light-neutral-10: #F9F8F2;\r\n    --light-neutral-11: #F2F9F8;\r\n    --light-neutral-12: #F9F2F2;\r\n    --light-neutral-13: #FEF5E3;\r\n    --light-neutral-14: #EAECFF;\r\n    --date-background: #F7F7F7;\r\n    --neutral-dark-1: #282c34;\r\n    /* Neutrals (texts/icons) */\r\n    --dark-neutral-1: #ACADAD;\r\n    --dark-neutral-2: #78828C;\r\n    --dark-neutral-3: #2D363D;\r\n    --dark-neutral-4: #373A3E;\r\n    --dark-neutral-5: #634701;\r\n    --dark-neutral-6: #630101;\r\n    --dark-neutral-7: #4D5154;\r\n    --almost-black: #303336;\r\n    --black: #000000;\r\n    --dark-neutral-text: #16171B;\r\n    /* Specials */\r\n    --star-yellow-1: #F19B50;\r\n    --star-yellow-2: #FFCC7F;\r\n    --star-yellow-3: #FFF8E7;\r\n    --green-1: #1D7A59;\r\n    --green-2: #A4E7C7;\r\n    --green-3: #EBFBE9;\r\n    --green-4: #016322;\r\n    --green-5: #1A936F;\r\n    --red-1: #EC4646;\r\n    --red-2: #FFAFAF;\r\n    --red-3: #FBE9F1;\r\n    --red-4: #FCE1E1;\r\n    --red-5: #FFEDEB;\r\n    --red-6: #FFDADA;\r\n    --link-blue: #0057FF;\r\n    --system-blue: #3A82F7;\r\n    --disclaimer-1: #514B28;\r\n    --disclaimer-2: #D6D0B4;\r\n    --disclaimer-3: #FFF5C1;\r\n    --disclaimer-4: #A5540E;\r\n    --red-button: #B91F1F;\r\n    --border-color: #434CB8;\r\n    --link-color: #1C33FF;\r\n    --active-speaker-div: #B6BAE6;\r\n    --border-light: #ebebeb;\r\n    --border-top-light: #e1e1e1;\r\n    --neutral-overlay: #373B6857;\r\n    --shadow-color: #9597B28C;\r\n    --shadow-color-light: #9395AE;\r\n    --red-alert: #E70000;\r\n    --red-alert-2: #F55014;\r\n    --success-background: #D4F4DD;\r\n    --error-background: #F8D7DA;\r\n    --success-text: #155724;\r\n    --error-text: #721C24;\r\n    --tooltip-text: #25284C;\r\n\r\n    --border-neutral: #EEEEEE;\r\n    /* Chips bg colors */\r\n    --accent-peach: #FFEAE8;\r\n    --accent-lavender: #E8ECFF;\r\n    --accent-amber: #FFECBD;\r\n    --accent-lilac: #FFEBFF;\r\n    --accent-mint: #F3FBEE;\r\n    --accent-rose: #FFDEDF;\r\n    --accent-apricot: #FFF4E6;\r\n    --accent-periwinkle: #E6E6FF;\r\n    /* chips border colors */\r\n    --border-peach: #FDCBC6;\r\n    --border-lavender: #CCD5FF;\r\n    --border-amber: #FBDA87;\r\n    --border-lilac: #FFC4FF;\r\n    --border-mint: #C6FFA2;\r\n    --border-rose: #FFA5A8;\r\n    --border-apricot: #FFD6A2;\r\n    --border-periwinkle: #B5B5FF;\r\n    /* chips text colors */\r\n    --text-peach: #9C4221;\r\n    --text-lavender: #2741BB;\r\n    --text-amber: #5E4300;\r\n    --text-lilac: #B309B3;\r\n    --text-mint: #2E7900;\r\n    --text-rose: #940004;\r\n    --text-apricot: #542F00;\r\n    --text-periwinkle: #2525E5;\r\n}\r\n\r\n.iframe-theme{\r\n    /* Primaries */\r\n    --primary-dark: #DA5B54;\r\n    --primary-dark-1: #013263;\r\n    --primary-dark-2: #DA5B54;\r\n    --primary-medium: #6F78DE;\r\n    --primary-medium-2: #EEEFFB;\r\n    --primary-medium-light: #9197da;\r\n    --primary-light: #DCDFFF;\r\n    --primary-light-2: #F4F5FF;\r\n    --primary-light-3: #D5D7EE;\r\n    --link-primary: #61dafb;\r\n    --hover-primary-dark: #3b44a2;\r\n    /* Neutrals (backgrounds/ layout blocks/ outlines) */\r\n    --neutral-white: #FFFFFF;\r\n    --light-neutral-1: #FDFDFD;\r\n    --light-neutral-2: #F2F3F9;\r\n    --light-neutral-3: #EEE7E7;\r\n    --light-neutral-4: #EEE7E7;\r\n    --light-neutral-5: #D9D9D9;\r\n    --light-neutral-6: #F7F8FB;\r\n    --light-neutral-7: #D1CAE1;\r\n    --light-neutral-8: #949494;\r\n    --light-neutral-9: #FFE5EA;\r\n    --light-neutral-10: #F9F8F2;\r\n    --light-neutral-11: #F2F9F8;\r\n    --light-neutral-12: #F9F2F2;\r\n    --light-neutral-13: #FFF6F8;\r\n    --light-neutral-14: #EAECFF;\r\n    --date-background: #F7F7F7;\r\n    --neutral-dark-1: #282c34;\r\n    /* Neutrals (texts/icons) */\r\n    --dark-neutral-1: #ACADAD;\r\n    --dark-neutral-2: #78828C;\r\n    --dark-neutral-3: #2D363D;\r\n    --dark-neutral-4: #373A3E;\r\n    --dark-neutral-5: #634701;\r\n    --dark-neutral-6: #630101;\r\n    --dark-neutral-7: #4D5154;\r\n    --almost-black: #303336;\r\n    --black: #000000;\r\n    --dark-neutral-text: #16171B;\r\n    /* Specials */\r\n    --star-yellow-1: #F19B50;\r\n    --star-yellow-2: #FFCC7F;\r\n    --star-yellow-3: #FFF8E7;\r\n    --green-1: #1D7A59;\r\n    --green-2: #A4E7C7;\r\n    --green-3: #EBFBE9;\r\n    --green-4: #016322;\r\n    --green-5: #1A936F;\r\n    --red-1: #EC4646;\r\n    --red-2: #FFAFAF;\r\n    --red-3: #FBE9F1;\r\n    --red-4: #FCE1E1;\r\n    --red-5: #FFEDEB;\r\n    --red-6: #FFDADA;\r\n    --link-blue: #0057FF;\r\n    --system-blue: #3A82F7;\r\n    --disclaimer-1: #514B28;\r\n    --disclaimer-2: #D6D0B4;\r\n    --disclaimer-3: #FFF5C1;\r\n    --disclaimer-4: #A5540E;\r\n    --red-button: #B91F1F;\r\n    --border-color: #DA5B54;\r\n    --link-color: #1C33FF;\r\n    --active-speaker-div: #FFEDEB;\r\n    --border-light: #ebebeb;\r\n    --border-top-light: #e1e1e1;\r\n    --neutral-overlay: #373B6857;\r\n    --shadow-color: #9597B28C;\r\n    --shadow-color-light: #9395AE;\r\n    --red-alert: #E70000;\r\n    --red-alert-2: #F55014;\r\n    --success-background: #D4F4DD;\r\n    --error-background: #F8D7DA;\r\n    --success-text: #155724;\r\n    --error-text: #721C24;\r\n    --tooltip-text: #25284C;\r\n\r\n    --border-neutral: #EEEEEE;\r\n    /* Chips bg colors */\r\n    --accent-peach: #FFEAE8;\r\n    --accent-lavender: #E8ECFF;\r\n    --accent-amber: #FFECBD;\r\n    --accent-lilac: #FFEBFF;\r\n    --accent-mint: #F3FBEE;\r\n    --accent-rose: #FFDEDF;\r\n    --accent-apricot: #FFF4E6;\r\n    --accent-periwinkle: #E6E6FF;\r\n    /* chips border colors */\r\n    --border-peach: #FDCBC6;\r\n    --border-lavender: #CCD5FF;\r\n    --border-amber: #FBDA87;\r\n    --border-lilac: #FFC4FF;\r\n    --border-mint: #C6FFA2;\r\n    --border-rose: #FFA5A8;\r\n    --border-apricot: #FFD6A2;\r\n    --border-periwinkle: #B5B5FF;\r\n    /* chips text colors */\r\n    --text-peach: #9C4221;\r\n    --text-lavender: #2741BB;\r\n    --text-amber: #5E4300;\r\n    --text-lilac: #B309B3;\r\n    --text-mint: #2E7900;\r\n    --text-rose: #940004;\r\n    --text-apricot: #542F00;\r\n    --text-periwinkle: #2525E5;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
